if(document.getElementById('cart-sidebar')){
    // klaviyo
    var _learnq = window._learnq || [];

    // let user_ip = null;
    // $.getJSON('https://api.db-ip.com/v2/free/self', function(data) {
    //     let ip = JSON.stringify(data, null, 2);
    //     user_ip = data.ipAddress;
    // });
    const cart_expiration_min = 120
    const duration_pa = 300 // animation speed for Product Accordion
    const cartSidebar = document.getElementById('cart-sidebar')
    const productSelectorNextStep = document.getElementById('product-selector-next-step')
    const inCartItemsContainer = document.getElementById('cart-items-list')
    const itemVariationHead = document.querySelectorAll('.item-variation-head')
    const cartCheckoutWrp = document.getElementById('cart-checkout-wrp')
    const productsAvailable = document.getElementById('products-available')
    const mayAlsoLike = document.getElementById('may-also-like')
    const cartWarrantyItem = document.querySelectorAll('.cart-warranty-item')
    const productVariantSelectorRadio = document.querySelectorAll('.product-variant-selector-radio')
    const cartProductItemButton = document.querySelectorAll('.cart-product-item-button')
    const cartItemRemoveButton = document.querySelectorAll('.cart-item-remove')
    const inCartItemHead = document.querySelectorAll('.in-cart-item-head')
    const inCartItemToggleButton = document.querySelectorAll('.in-cart-item-toggle-button')
    const bulkQtMinusButton = document.querySelectorAll('.bulk-qt-minus')
    const bulkQtPlusButton = document.querySelectorAll('.bulk-qt-plus')
    const footerTaxContainer = document.querySelector('.products-in-cart-footer-tax')
    const footerTaxValue = document.getElementById('tax-value')
    //const footerTaxText = document.getElementById('tax-text')

    


    // const extendedWarrantyID = '44291104473356'
    // Regular price 44291104473356
    // Free 53879113548044
    
    // const currencySymbolPositionBefore = {
    //     "$": true,
    //     "€": true,
    //     "£": true,
    //     "CHF": true,
    //     "zł": false,
    //     "kr": false,
    //     "Kč": false
    // }
    
    const taxRegions = {
        "ch": {"rate": "17", "country": "Switzerland"},
        "no": {"rate": "25", "country": "Norway"},
    }


    const cartCheckoutButton = document.getElementById('cart-checkout-button')
    const checkoutButtonPriceEl = cartCheckoutButton.querySelector('.cart-checkout-button-price')
    const mobileMenuWrp = document.querySelector('.header-mobile-menu-wrp')

    var unitsInCartTotalDiscountAffects = 0
    


    const sidebarHide = document.getElementById('sidebar-cart-hide')
    sidebarHide.addEventListener('click',  (e) => {
            document.body.classList.remove('sidebar-open')
    })

    const sidebarOpen = document.getElementById('sidebar-cart-open')
    if(sidebarOpen){
        sidebarOpen.addEventListener('click',  (e) => {
            document.body.classList.add('sidebar-open')
        })

        document.addEventListener('click', (e) => {
            if( e.target.closest('.needsclick') ){
                return false
            }
            if ( !cartSidebar.contains(e.target) && !sidebarOpen.contains(e.target) ) {
                document.body.classList.remove('sidebar-open')
            }
        });
    }
    
    
    

    

    document.addEventListener('DOMContentLoaded', () => {
        init()
    })

    function init() {
        if(checkStateExpired()) {
            restoreState()
            setUnitsQuantity()
            discounts()
        }
        safari_detector()
        footerReposition()
        setTimeout(preloadAllImages, 1000)
    }

    function checkStateExpired(){
        let date = localStorage.getItem("cart_date")
        if( date != null ){
            let dateNow = Date.now()
            let dif = (dateNow - date) / 1000 / 60
            if( dif > cart_expiration_min ){
                console.log('Cart CLEARED');
                localStorage.removeItem('cart_state');
                localStorage.removeItem('cart_date');
            }else{
                console.log('Cart LOADED');
                return true
            }
        }else{
            console.log('Cart CLEARED');
            localStorage.removeItem('cart_state');
            localStorage.removeItem('cart_date');
        }
        return false
    }

    

    // save state
    function saveState(){
        let s = getState()
        let state = JSON.stringify(s)
        localStorage.setItem("cart_state", state)
        localStorage.setItem("cart_date", Date.now())
        klaviyoTrack(s)
    }

    function klaviyoTrack(state){
        if(window.location.hash == '#test'){
            let item = {}
            let products = []
            state.forEach((stateItem) => {
                if(stateItem.items){
                    stateItem.items.forEach((i) => {
                        let imageURL = getProductImageById(i.variantId)
                        let title = getProductTitleById(i.variantId)
                        products.push({"id": i.variantId, "image": imageURL, "title": title, "quantity": i.quantity})
                    })
                }
            })

            if(state.length == 0){
                item = {
                    total_price: 0,
                    $value: 0,
                    items: 'Shopping cart is empty'
                };
            }else{
                let price = checkoutButtonPriceEl.innerHTML;
                item = {
                    total_price: price,
                    $value: price,
                    currency: currencySymbol,
                    items: products,
                    locale: document.documentElement.lang
                };
            }
            

            let r = _learnq.push(['track', 'Added to Cart', item]);
            console.log('Klaviyo track - Added to Cart: ', r);
        }
    }

    // const productDiscountList = {
    //     'product-luminette-3': {
    //         affects_discount: true,
    //         accepts_discount: true,
    //     },
    //     'product-luminette-2': {
    //         affects_discount: true,
    //         accepts_discount: true,
    //     },
    //     'product-drive': {
    //         affects_discount: true,
    //         accepts_discount: true,
    //     },
    //     'product-nose-rest-for-luminette-3': {
    //         affects_discount: false,
    //         accepts_discount: false,
    //     },
    //     'product-nose-rest-for-luminette-2': {
    //         affects_discount: false,
    //         accepts_discount: false,
    //     },
    //     // 'product-nose-rest': {
    //     //     affects_discount: false,
    //     //     accepts_discount: false,
    //     // },
    // }
    

    // the array is outputs in cart-sidebar.liquid
    // const productDiscountAmounts = [
    // // 0  1   2   3   4   5   6   7   8   9  10  11  12  13  14  15  16  17  18  19  20  21  22  23  24 - units 
    //    0, 0, 20, 25, 25, 25, 30, 30, 30, 30, 30, 30, 35, 35, 35, 35, 35, 35, 35, 35, 35, 35, 35, 35, 40 - discount percentage
    // ]
    
    

    function getDiscountAmoumt(qt){
        if(qt > productDiscountAmounts.length - 1 ){
            return productDiscountAmounts[productDiscountAmounts.length - 1]
        }else{
            return productDiscountAmounts[qt]
        }
    }

    function getAccessoriesDiscountAmoumt(qt){
        if(qt > accessoriesDiscountAmounts.length - 1 ){
            return accessoriesDiscountAmounts[accessoriesDiscountAmounts.length - 1]
        }else{
            return accessoriesDiscountAmounts[qt]
        }
    }


    function discounts(){
        let activeProducts = document.querySelectorAll('.in-cart-item.active')
        let productsAvailable = document.querySelectorAll('.cart-product-item.active') 
        let totalPrice = 0
        let enableDiscount = false
        var accessoriesInCartTotal = 0

        // first iteration
        activeProducts.forEach((product) => {
            let productId = product.id
            if(productDiscountList[productId].affects_discount){
                enableDiscount = true
            }
            if(product.dataset.collection == 'accessories'){
                accessoriesInCartTotal += parseInt(product.dataset.unitsTotal)
            }
        })
        
        // second iteration
        activeProducts.forEach((product) => {
            let productBasePrice = product.dataset.basePrice
            let curUnitsTotal = parseInt(product.dataset.unitsTotal)
            let productMinimizedPriceEl = product.querySelector('.in-cart-item-minimized-info-price-value')

            if( productDiscountList[product.id].accepts_discount ){

                // product accepts discount
                let curTotalDiscount = getDiscountAmoumt(unitsInCartTotalDiscountAffects)
                
                let productMinimizedDiscountBadge = product.querySelector('.in-cart-item-minimized-info-discount-badge')
                if(curTotalDiscount != 0){
                    productMinimizedDiscountBadge.classList.add('active')
                }else{
                    productMinimizedDiscountBadge.classList.remove('active')
                }
                productMinimizedDiscountBadge.innerHTML = '-' + curTotalDiscount + '%'
                
                let curMinimizedPriceWithDiscount = productBasePrice * curUnitsTotal * ( 100 - curTotalDiscount ) / 10000
                productMinimizedPriceEl.innerHTML = getPromotionalPrice(curMinimizedPriceWithDiscount).toFixed()
                
                if( product.classList.contains('more-units') ){
                    // bulk mode
                    let variationMore = product.querySelector('.in-cart-item-variations-more')
                    let variationMoreDiscountBadge = variationMore.querySelector('.product-discount-badge')
                    let curVariationDiscountAmount = getDiscountAmoumt(unitsInCartTotalDiscountAffects)
                    variationMoreDiscountBadge.classList.add('short-discount');
                    variationMoreDiscountBadge.innerHTML = '-' + curVariationDiscountAmount + '%'
                    let variationMorePriceValueEl =  variationMore.querySelector('.item-variation-price-value')
                    let variationMorePriceValue = productBasePrice * (100 - curVariationDiscountAmount) * curUnitsTotal / 10000
                    let variationMorePricePerUnitEl = variationMore.querySelector('.item-variation-price-per-unit-value')
                    let variationMorePricePerUnitValue = productBasePrice * (100 - curVariationDiscountAmount) / 10000
                    variationMorePriceValueEl.innerHTML = getPromotionalPrice(variationMorePriceValue).toFixed()
                    let variationMorePricePerUnitValueFixed = getPromotionalPrice(variationMorePricePerUnitValue).toFixed()
                    variationMorePricePerUnitEl.innerHTML = variationMorePricePerUnitValueFixed
                    //variationMore.dataset.totalPrice = productBasePrice * (100 - curVariationDiscountAmount) * curUnitsTotal
                    totalPrice += productBasePrice * (100 - curVariationDiscountAmount) * curUnitsTotal / 100

                    let bulkBenefitObject = product.querySelector('.item-variation-more-price-benefit-value')
                    if(bulkBenefitObject){
                        bulkBenefitObject.innerHTML = (productBasePrice * curUnitsTotal / 100 - variationMorePriceValue).toFixed()
                    }

                }else{
                    // retail mode
                    let productVariations = product.querySelectorAll('.item-variation')
                    let activeVariationQuantity = parseInt(product.querySelector('.item-variation.active').dataset.quantity)
                    productVariations.forEach((variation, index) => {
                        let curVariationQuantity = parseInt(variation.dataset.quantity)
                        let curVariationDiscountBdge = variation.querySelector('.product-discount-badge')
                        let curVariationDiscountAmount = getDiscountAmoumt(unitsInCartTotalDiscountAffects - curUnitsTotal + curVariationQuantity)
                        
                        let curTagText = ''
                        if(variation.classList.contains('active')){
                            curTagText = translsteDiscountTagNew(unitsInCartTotalDiscountAffects)
                        }else{
                            let i = activeVariationQuantity - 1
                            curTagText = translsteDiscountTagNew(unitsInCartTotalDiscountAffects + index - i)
                        }
                        if(curTagText == ''){
                            curVariationDiscountBdge.innerHTML = ''
                            curVariationDiscountBdge.classList.add('hidden')
                        }else{
                            curVariationDiscountBdge.innerHTML = curTagText
                            curVariationDiscountBdge.classList.remove('hidden')
                        }
                        

                        let variationPerUnitPriceValueEl = variation.querySelector('.variation-per-unit-price-value')
                        let variationPerUnitPriceValue = getPromotionalPrice(productBasePrice * (100 - curVariationDiscountAmount) / 10000)
                        variationPerUnitPriceValueEl.innerHTML = variationPerUnitPriceValue.toFixed()
                        let variationPriceValueEl = variation.querySelector('.item-variation-price-value')
                        let variationPriceValue = variationPerUnitPriceValue * curVariationQuantity
                        variationPriceValueEl.innerHTML = variationPriceValue.toFixed()
                        //variation.dataset.totalPrice = productBasePrice * (100 - curVariationDiscountAmount) * curVariationQuantity / 100
                        if( curVariationDiscountAmount > 0 ){
                            curVariationDiscountBdge.classList.remove('hidden')
                        }else{
                            if(!cartSidebar.classList.contains('cart-promotional') && index != 0){
                                curVariationDiscountBdge.classList.add('hidden')
                            }else{
                                curVariationDiscountBdge.innerHTML = tagTranslationAll['units1']
                            }
                        }
                        if( variation.classList.contains('active') ){
                            totalPrice += productBasePrice * (100 - curVariationDiscountAmount) * curUnitsTotal / 100
                        }

                        // benefit
                        let variationBenefitObject = variation.querySelector('.item-variation-price-benefit')
                        if(variationBenefitObject){
                            variationBenefitObject.innerHTML = (productBasePrice * curVariationQuantity / 100 - variationPriceValue).toFixed()
                        }
                        
                    })
                }
            }else{

                // product does NOT accept discount

                if(product.dataset.collection == 'accessories'){
                    // accessories

                    let curTotalDiscount = getAccessoriesDiscountAmoumt(accessoriesInCartTotal)
                    let curMinimizedPriceWithDiscount = productBasePrice * curUnitsTotal * ( 100 - curTotalDiscount ) / 10000
                    productMinimizedPriceEl.innerHTML = getPromotionalPrice(curMinimizedPriceWithDiscount).toFixed()

                    let productMinimizedDiscountBadge = product.querySelector('.in-cart-item-minimized-info-discount-badge')
                    if(curTotalDiscount != 0){
                        productMinimizedDiscountBadge.classList.add('active')
                    }else{
                        productMinimizedDiscountBadge.classList.remove('active')
                    }
                    productMinimizedDiscountBadge.innerHTML = '-' + curTotalDiscount + '%'

                    if( product.classList.contains('more-units') ){
                        // bulk mode
                        let variationMore = product.querySelector('.in-cart-item-variations-more')
                        let variationMoreDiscountBadge = variationMore.querySelector('.product-discount-badge')
                        let curVariationDiscountAmount = getAccessoriesDiscountAmoumt(accessoriesInCartTotal)
                        variationMoreDiscountBadge.innerHTML = '-' + curVariationDiscountAmount + '%'
                        if(curVariationDiscountAmount == 0){
                            variationMoreDiscountBadge.classList.add('hidden')
                        }else{
                            variationMoreDiscountBadge.classList.remove('hidden')
                        }
                        let variationMorePriceValueEl = variationMore.querySelector('.item-variation-price-value')
                        let variationMorePriceValue = productBasePrice * (100 - curVariationDiscountAmount) * curUnitsTotal / 10000
                        let variationMorePricePerUnitEl = variationMore.querySelector('.item-variation-price-per-unit-value')
                        let variationMorePricePerUnitValue = productBasePrice * (100 - curVariationDiscountAmount) / 10000
                        variationMorePriceValueEl.innerHTML = getPromotionalPrice(variationMorePriceValue).toFixed()
                        variationMorePricePerUnitEl.innerHTML = getPromotionalPrice(variationMorePricePerUnitValue).toFixed()
                        //variationMore.dataset.totalPrice = productBasePrice * (100 - curVariationDiscountAmount) * curUnitsTotal
                        totalPrice += productBasePrice * (100 - curVariationDiscountAmount) * curUnitsTotal / 100
                    }else{
                        // retail mode

                        let productVariations = product.querySelectorAll('.item-variation')
                        let activeVariationQuantity = parseInt(product.querySelector('.item-variation.active').dataset.quantity)
                        productVariations.forEach((variation, index) => {
                            
                            let curVariationQuantity = parseInt(variation.dataset.quantity)
                            let curVariationDiscountBdge = variation.querySelector('.product-discount-badge')
                            let curVariationDiscountAmount = getAccessoriesDiscountAmoumt(accessoriesInCartTotal - curUnitsTotal + curVariationQuantity)
                            let variationPerUnitPriceValue = getPromotionalPrice(productBasePrice * (100 - curVariationDiscountAmount) / 10000)

                            let variationPriceValueEl = variation.querySelector('.item-variation-price-value')
                            let variationPriceValue = variationPerUnitPriceValue * curVariationQuantity
                            variationPriceValueEl.innerHTML = variationPriceValue.toFixed()

                            let variationPerUnitPriceValueEl = variation.querySelector('.variation-per-unit-price-value')
                            variationPerUnitPriceValueEl.innerHTML = variationPerUnitPriceValue.toFixed()
                            
                            if(variation.classList.contains('active')){
                                curTagText = translsteAccessoriesDiscountTagNew(accessoriesInCartTotal)
                            }else{
                                let i = activeVariationQuantity - 1
                                curTagText = translsteAccessoriesDiscountTagNew(accessoriesInCartTotal + index - i)
                            }
                            if(curTagText == ''){
                                curVariationDiscountBdge.innerHTML = ''
                                curVariationDiscountBdge.classList.add('hidden')
                            }else{
                                curVariationDiscountBdge.innerHTML = curTagText
                                curVariationDiscountBdge.classList.remove('hidden')
                            }
                            if(curVariationDiscountAmount == 0){
                                curVariationDiscountBdge.classList.add('hidden')
                            }else{
                                curVariationDiscountBdge.classList.remove('hidden')
                            }
                        })
                        curVariationDiscountAmount = getAccessoriesDiscountAmoumt(accessoriesInCartTotal)
                        totalPrice += productBasePrice * (100 - curVariationDiscountAmount) * curUnitsTotal / 100
                    }

                    
                }else{
                    if( product.classList.contains('more-units') ){
                        // bulk mode
                        let variationMore = product.querySelector('.in-cart-item-variations-more')
                        let variationMorePriceValueEl =  variationMore.querySelector('.item-variation-price-value')
                        let variationMorePriceValue = productBasePrice * curUnitsTotal / 100
                        variationMorePriceValueEl.innerHTML = getPromotionalPrice(variationMorePriceValue).toFixed()
                    }else{
                        // retail mode
                    }
                    let productPriceWithoutDiscount = parseInt(product.dataset.basePrice) * parseInt(product.dataset.unitsTotal)
                    productMinimizedPriceEl.innerHTML = (productPriceWithoutDiscount / 100).toFixed()
                    totalPrice += productPriceWithoutDiscount
                }
            }
            let warrantyPrice = getWarrantyPrice(product) * curUnitsTotal
            totalPrice += warrantyPrice
        })
        

        // discounts for Available products (not in cart)
        if( enableDiscount === true ){
            let activeProductsCount = activeProducts.length
            if(activeProductsCount){
                var potentialPriceTotal = 0
                var currentPriceTotal = 0
                let activeProductsUnitsTotal = 0
                activeProducts.forEach((product) => {
                    activeProductsUnitsTotal += parseInt(product.dataset.unitsTotal)
                })
                var potentialDiscountAmount = getDiscountAmoumt(activeProductsUnitsTotal + 1)
                var currentDiscountAmount = getDiscountAmoumt(activeProductsUnitsTotal)
                activeProducts.forEach((product) => {
                    let productBasePrice = product.dataset.basePrice
                    let curUnitsTotal = parseInt(product.dataset.unitsTotal)
                    potentialPriceTotal += productBasePrice * curUnitsTotal * ( 100 - potentialDiscountAmount ) / 10000
                })
                activeProducts.forEach((product) => {
                    let productBasePrice = product.dataset.basePrice
                    let curUnitsTotal = parseInt(product.dataset.unitsTotal)
                    currentPriceTotal += productBasePrice * curUnitsTotal * ( 100 - currentDiscountAmount ) / 10000
                })
            }
            
            let discountAmoumt = getDiscountAmoumt(unitsInCartTotalDiscountAffects + 1)
            productsAvailable.forEach((productAvailable) => {
                let productHandle = productAvailable.dataset.productHandle
                if( productDiscountList[productHandle] != undefined && productDiscountList[productHandle].accepts_discount ){
                    if( !productAvailable.classList.contains('has-discount') ){
                        productAvailable.classList.add('has-discount')
                    }
                    let badge = productAvailable.querySelector('.product-discount-badge')
                    if( badge ){
                        // badge.innerHTML = '-' + discountAmoumt+'%'
                        let tagQt = unitsInCartTotalDiscountAffects + 1
                        if (tagQt >= 5) {
                            badge.classList.add('short-discount');
                        }else{
                            badge.classList.remove('short-discount');
                        }
                        //badge.innerHTML = translsteDiscountTagNew(tagQt)
                        badge.innerHTML = translsteDiscountTagOrderTogether(tagQt)
                    }
                    let productAvailableBasePrice = productAvailable.dataset.basePrice
                    let newPriceEl = productAvailable.querySelector('.cart-product-item-price-current-value')
                    let btnPriceEl = productAvailable.querySelector('.cart-product-item-price')
                    let itemPriceEl = productAvailable.querySelector('.variation-per-unit-price-value')
                    let newPrice = productAvailableBasePrice * (100 - discountAmoumt) / 10000

                    if(newPriceEl){
                        newPriceEl.innerHTML = getPromotionalPrice(newPrice).toFixed()
                    }
                    if(btnPriceEl){
                        console.log('itemPriceEl', itemPriceEl)
                        itemPriceEl.innerHTML = getPromotionalPrice(newPrice).toFixed();
                        //btnPriceEl.innerHTML = getPromotionalPrice(newPrice).toFixed()
                        let itemPotentialPrice = getPromotionalPrice(productAvailableBasePrice * (100 - potentialDiscountAmount) / 10000)
                        btnPriceEl.innerHTML = (itemPotentialPrice - (getPromotionalPrice(currentPriceTotal) - getPromotionalPrice(potentialPriceTotal))).toFixed()
                    }
                }
            })
        }else{
            productsAvailable.forEach((productAvailable) => {
                let productHandle = productAvailable.dataset.productHandle
                if( productDiscountList[productHandle].accepts_discount ){
                    if( productAvailable.classList.contains('has-discount') ){
                        productAvailable.classList.remove('has-discount')
                    }
                }
            })
        }   

        productsAvailable.forEach((productAvailable) => {
            if( !productAvailable.classList.contains('primary-product') && !productAvailable.classList.contains('out-of-stock') ){
                let badge = productAvailable.querySelector('.product-discount-badge')
                let itemPriceObj = productAvailable.querySelector('.cart-product-item-price')
                if(accessoriesInCartTotal >= 1){
                    productAvailable.classList.add('has-discount')
                }else{
                    productAvailable.classList.remove('has-discount')
                }
                if(badge){
                    if(accessoriesInCartTotal >= 1){
                        let discountAmoumt = getAccessoriesDiscountAmoumt(accessoriesInCartTotal + 1)
                        badge.classList.remove('hidden')
                        badge.innerHTML = '-'+discountAmoumt+'%'
                    }else{
                        badge.classList.add('hidden')
                    }
                }
                if(itemPriceObj){
                    let priceBase = parseInt(productAvailable.dataset.basePrice) / 100
                    let discountAmoumt = getAccessoriesDiscountAmoumt(accessoriesInCartTotal + 1)
                    let priceWithDiscount = Math.round(priceBase * (100 - discountAmoumt) / 100)
                    itemPriceObj.innerHTML = priceWithDiscount
                }
            }
        })

        // totoal price
        
        let priceFloat = totalPrice / 100
        checkoutButtonPriceEl.innerHTML = getPromotionalPrice(priceFloat).toFixed()
        setTaxInFooter()
        
    }

    function getWarrantyPrice(product){
        let productWarrantyActive = product.querySelector('.cart-warranty-item.warranty-extended.active')
        if(productWarrantyActive){
            return parseInt(productWarrantyActive.dataset.warrantyPrice)   
        }else{
            return 0
        }
    }

    
    

    function restoreState(){
        let state = JSON.parse(localStorage.getItem("cart_state"))
        if( state.length > 0 ){
            cartSidebar.classList.add('step-2')
            state.forEach((product) => {
                let curProduct = document.getElementById(product.productId)
                if(curProduct){
                    // activate
                    curProduct.classList.add('active')
                    // set order
                    curProduct.style.order = product.order
                    // Minimized
                    toggleMinimized(curProduct, true)
                    // set mode
                    if(product.mode == 'bulk'){
                        setBulkMode(curProduct, true)
                        if(curProduct.classList.contains('has-color-variants')){
                            let totalQuantity = 0
                            product.items.forEach((item) => {
                                let variationInput = curProduct.querySelector('.bulk-variation-color-input[data-bulk-color="'+item.color+'"]')
                                variationInput.value = item.quantity
                                let indicator = curProduct.querySelector('.color-indicator.color-'+item.color)
                                let btnMinus = variationInput.previousElementSibling
                                totalQuantity = totalQuantity + item.quantity
                                if( item.quantity == 0 ){
                                    indicator.classList.add('disabled')
                                }else{
                                    indicator.classList.remove('disabled')
                                }
                                if( item.quantity == 0 ){
                                    btnMinus.disabled = true
                                }else{
                                    btnMinus.disabled = false
                                }
                                let curProductMinusButtons = curProduct.querySelectorAll('.bulk-qt-minus')
                                if(product.totalUnits <= 4){
                                    curProductMinusButtons.forEach((button) => {
                                        button.disabled = true
                                    })
                                }
                            })
                        }else{
                            let variationInput = curProduct.querySelector('.bulk-variation-input')
                            if( variationInput && product.items[0] ){
                                variationInput.value = product.items[0].quantity
                                let btnMinus = variationInput.previousElementSibling
                                if( parseInt(product.items[0].quantity) > 4 ){
                                    btnMinus.disabled = false
                                }
                            }
                        }
                        
                        bulkImageVariant(curProduct)
                    }else{
                        
                        curProduct.querySelectorAll('.item-variation').forEach((variation) => {
                            if( variation.dataset.quantity == product.totalUnits ){
                                variation.classList.add('active')
                                variation.querySelectorAll('.item-variation-item-colors').forEach((variationItem, index) => {
                                    if(product.items[index].color){
                                        let radio = variationItem.querySelector('.product-variant-selector-radio[data-color="'+product.items[index].color+'"]')
                                        radio.checked = true
                                        setVariation(radio)
                                    }
                                })
                            }else{
                                variation.classList.remove('active')
                            }
                            
                            
                        })
                        setBulkMode(curProduct, false)
                        if( product.totalUnits > 1 ){
                            setWarrantyBulk(curProduct, true)
                        }
                    }
                    if( product.warranty == 1 ){
                        curProduct.querySelector('.cart-warranty-item.active').classList.remove('active')
                        let warrantyExt = curProduct.querySelector('.cart-warranty-item.warranty-extended')
                        if( warrantyExt ){
                            warrantyExt.classList.add('active')
                        }
                    }
                    if( productDiscountList[product.productId].affects_discount ){
                        unitsInCartTotalDiscountAffects += parseInt(product.totalUnits)
                    }

                }
            })
            showRelatedProducts()
        }
    }

    

    // get state
    function getState(){
        var state = []
        unitsInCartTotalDiscountAffects = 0
        let activeProducts = document.querySelectorAll('.in-cart-item.active')
        activeProducts.forEach((activeProduct) => {
            let activeProductTotalUnits = 0
            let warrantySelected = activeProduct.querySelector('.cart-warranty-item.active')
            let warranty = 0
            if( warrantySelected !== null && warrantySelected.classList.contains('warranty-extended') ){
                warranty = 1
            }
            if( activeProduct.classList.contains('has-color-variants') ){
                // has color variants
                let items = []
                if(activeProduct.classList.contains('more-units')){
                    // product in bulk mode
                    let totalUnits = 0
                    activeProduct.querySelectorAll('.bulk-variation-input').forEach((variation) => {
                        totalUnits = totalUnits + parseInt(variation.value)
                        items.push(
                            {
                                variantId: variation.dataset.variantId,
                                quantity: variation.value,
                                color: variation.dataset.bulkColor
                            }
                        )
                    })
                    state.push(
                        {
                            productId: activeProduct.id,
                            mode: 'bulk',
                            order: activeProduct.style.order,
                            totalUnits: totalUnits,
                            warranty: warranty,
                            items: items,
                        }
                    )
                    activeProductTotalUnits += totalUnits
                }else{
                    // product in retail mode
                    let productActiveVarition = activeProduct.querySelector('.item-variation.active')
                    let variantsSelectors = productActiveVarition.querySelectorAll('.product-variant-selector-radio')
                    let totalUnits = 0
                    variantsSelectors.forEach((variation) => {
                        if(variation.checked){
                            totalUnits++
                            items.push({
                                variantId: variation.value,
                                quantity: 1,
                                color: variation.dataset.color
                            })
                        }
                    })
                    state.push(
                        {
                            productId: activeProduct.id,
                            mode: 'retail',
                            order: activeProduct.style.order,
                            totalUnits: totalUnits,
                            warranty: warranty,
                            items: items,
                        }
                    )
                    activeProductTotalUnits += totalUnits
                }
            }else{
                // has NO color variants
                let items = []
                let productId = activeProduct.dataset.defaultVariantId
                if(activeProduct.classList.contains('more-units')){
                    // product in bulk mode
                    let variation = activeProduct.querySelector('.bulk-variation-input')
                    if( variation ){
                        items.push(
                            {
                                variantId: productId,
                                quantity: variation.value,
                                color: null
                            }
                        )
                    }
                    state.push(
                        {
                            productId: activeProduct.id,
                            mode: 'bulk',
                            order: activeProduct.style.order,
                            totalUnits: variation.value,
                            warranty: warranty,
                            items: items
                        }
                    )
                    activeProductTotalUnits += parseInt(variation.value)
                }else{
                    // product in retail mode
                    let productActiveVarition = activeProduct.querySelector('.item-variation.active')
                    items.push({
                        variantId: productId,
                        quantity: productActiveVarition.dataset.quantity,
                        color: null
                    })
                    state.push(
                        {
                            productId: activeProduct.id,
                            mode: 'retail',
                            order: activeProduct.style.order,
                            totalUnits: productActiveVarition.dataset.quantity,
                            warranty: warranty,
                            items: items
                        }
                    )
                    activeProductTotalUnits += parseInt(productActiveVarition.dataset.quantity)
                }
            }
            if( productDiscountList[activeProduct.id].affects_discount ){
                unitsInCartTotalDiscountAffects += activeProductTotalUnits
            }
            
        })
        return state
    }

    // select product
    const productSelectorItem = document.querySelectorAll('.product-selector-item')
    productSelectorItem.forEach((item) => {
        item.addEventListener('click', (e) => {
            if( !item.classList.contains('active') && !item.classList.contains('out-of-stock') ){
                let curActiveProductItem = document.querySelector('.product-selector-item.active')
                let activeAccessoryItem = document.querySelector('.accessories-list-item.active')
                if(curActiveProductItem){
                    curActiveProductItem.classList.remove('active')
                }
                if(activeAccessoryItem){
                    activeAccessoryItem.classList.remove('active')
                }
                item.classList.add('active')
            }
        })
    })

    // to step #2
    productSelectorNextStep.addEventListener('click', (e) => {
        let curActiveProductItem = document.querySelector('.product-selector-item.active')
        let curActiveAccessoryItem = document.querySelector('.accessories-list-item.active')
        let targetProductId = null
        if(curActiveProductItem){
            targetProductId = curActiveProductItem.dataset.targetProduct
        }else if(curActiveAccessoryItem){
            targetProductId = curActiveAccessoryItem.dataset.targetProduct
        }else{
            return false;
        }
        cartSidebar.classList.add('step-2')
        let targetProduct = document.getElementById(targetProductId)
        addProduct(targetProduct)
        saveState()
    })

    // ADD related product to cart
    cartProductItemButton.forEach((item) => {
        item.addEventListener('click', (e) => {
            let productItem = item.closest('.cart-product-item')
            productItem.classList.remove('active')
            let handle = productItem.dataset.productHandle
            let currentProductEl = document.getElementById(handle)
            if( currentProductEl !== null ){
                addProduct(currentProductEl)
                saveState()
            }
        })
    })
    
    // add product function
    function addProduct(currentProductEl){
        let activeProducts = inCartItemsContainer.querySelectorAll('.in-cart-item.active')
        if( activeProducts.length == 0 ){
            currentProductEl.style.order = '1'
            currentProductEl.classList.add('active')
            // showRelatedProducts()
            // return
        }else{
            let orderNum = 1
            activeProducts.forEach((ap, index) => {
                let curOrderNum = parseInt(ap.style.order)
                if( curOrderNum > orderNum ){
                    orderNum = curOrderNum
                }
                toggleMinimized(ap, true)
            })
            orderNum++
            currentProductEl.style.order = orderNum
            currentProductEl.classList.add('active')
        }
        showRelatedProducts()
        setUnitsQuantity()
        discounts()
        
    }


    // REMOVE ptoduct from cart
    cartItemRemoveButton.forEach((item) => {
        item.addEventListener('click', (e) => {
            let currentProductEl = item.closest('.in-cart-item')
            currentProductEl.classList.remove('active')
            currentProductEl.style.order = ''
            toggleMinimized(currentProductEl, false)


            // -- clear user selection 
            if(currentProductEl.classList.contains('more-units')){
                if(currentProductEl.classList.contains('has-color-variants')){
                    let colorIndicators = currentProductEl.querySelectorAll('.color-indicator')
                    if(colorIndicators){
                        colorIndicators.forEach((colorIndicator) => {
                            if(colorIndicator.classList.contains('color-blue')){
                                colorIndicator.classList.remove('disabled')
                            }else{
                                colorIndicator.classList.add('disabled')
                            }
                        })
                    }
                    let bulkItemsWrp = currentProductEl.querySelectorAll('.more-bulk-item-wrp')
                    if(bulkItemsWrp){
                        bulkItemsWrp.forEach((bulkItem) => {
                            let btnMinus = bulkItem.querySelector('.bulk-qt-minus')
                            if(btnMinus){
                                btnMinus.disabled = true
                            }
                            let input = bulkItem.querySelector('.bulk-variation-color-input')
                            if(input.dataset.bulkColor == 'blue'){
                                input.value = 4
                            }else{
                                input.value = 0
                            }
                            
                        })
                    }
                }else{
                    let input = currentProductEl.querySelector('.bulk-variation-input') 
                    if(input){
                        input.value = 4
                    }
                    let btnMinus = currentProductEl.querySelector('.bulk-qt-minus') 
                    if(btnMinus){
                        btnMinus.disabled = true
                    }
                }
                setBulkMode(currentProductEl, false)
            }

            let itemVariationAll = currentProductEl.querySelectorAll('.item-variation')
            
            if(currentProductEl.classList.contains('has-image-variants')){
                itemVariationAll.forEach((item) => {
                    let itemQt = parseInt(item.dataset.quantity)
                    let defaultColors = new Array(itemQt).fill('blue')
                    item.dataset.colors = defaultColors.join('-')
                    item.dataset.color = defaultColors.join('-')
                    
                    let variationItemColors = currentProductEl.querySelectorAll('.item-variation-item-colors')
                    if(variationItemColors){
                        variationItemColors.forEach((itemColor) => {
                            let radioAll = itemColor.querySelectorAll('.product-variant-selector-radio')
                            if(radioAll){
                                radioAll.forEach((radio, index) => {
                                    if(index == 0){
                                        radio.checked = true
                                    }else{
                                        radio.checked = false
                                    }
                                })
                            }
                        })
                    }

                })
            }

            let currentProductVariationDefault = currentProductEl.querySelector('.item-variation')
            let curItemVariation = currentProductEl.querySelector('.item-variation.active')
            if(curItemVariation){
                if( currentProductVariationDefault != curItemVariation ) {
                    curItemVariation.classList.remove('active')
                    currentProductVariationDefault.classList.add('active')
                }
            }else{
                currentProductVariationDefault.classList.add('active')
            }
            let boxInfoActive = currentProductEl.querySelector('.product-box-info-image.active')
            if(boxInfoActive && !boxInfoActive.classList.contains('color-blue') ){
                boxInfoActive.classList.remove('active')
                currentProductEl.querySelector('.product-box-info-image.color-blue').classList.add('active')
            }
            changeColorVariationImage(currentProductEl)
            
            // -- END clear user selection 


            
            let productInCart = inCartItemsContainer.querySelectorAll('.in-cart-item.active')
            if( productInCart.length == 0 ){
                hideRelatedProductsAll()
                cartSidebar.classList.remove('step-2')
                saveState()
                setUnitsQuantity()
                discounts()
                e.stopPropagation()
                return false
            }
            if( productInCart.length == 1 ){
                toggleMinimized(productInCart[0], false)
                showRelatedProducts()
                setUnitsQuantity()
                saveState()
                discounts()
                e.stopPropagation()
                return false
            }
            if( productInCart.length > 1 ){
                let lastProduct = productInCart[0]
                let lastProductOrder = parseInt(productInCart[0].style.order)
                productInCart.forEach((product) => {
                    let curProductOrder = parseInt(product.style.order)
                    if( curProductOrder > lastProductOrder ){
                        lastProduct = product
                    }else{
                        //toggleMinimized(product, true)
                    }
                })
                toggleMinimized(lastProduct, false)
                showRelatedProducts()
                setUnitsQuantity()
                saveState()
                discounts()
                e.stopPropagation()
                return false
            }
        })
    })


    // Toggle product minimized
    inCartItemToggleButton.forEach((item) => {
        item.addEventListener('click', (e) => {
            let curProduct = item.closest('.in-cart-item')
            discounts()
            productAccordion(curProduct)
        })
    })

    function productAccordion(product){
        let productInCart = inCartItemsContainer.querySelectorAll('.in-cart-item.active')
        productInCart.forEach((curProduct) =>{
            let itemBody = curProduct.querySelector('.in-cart-item-body')
            if( product == curProduct ){
                if(product.classList.contains('minimized')){
                    curProduct.classList.remove('minimized')
                    //$(itemBody).slideDown(duration_pa)
                }else{
                    curProduct.classList.add('minimized')
                    //$(itemBody).slideUp(duration_pa)
                }
            }else{
                curProduct.classList.add('minimized')
                //$(itemBody).slideUp(duration_pa)
            }
        })
    }


    // You may also like products
    function showRelatedProducts(){
        
        let productInCart = inCartItemsContainer.querySelectorAll('.in-cart-item.active')
        let productAvailable = productsAvailable.querySelectorAll('.cart-product-item')
        let inCart = []
        //let recomended = []
        //let recomendedAccessories = []
        
        productInCart.forEach((item) => {
            inCart.push(item.id)
        })

        let firstRecomended = null

        if( !inCart.includes('product-luminette-3') && !inCart.includes('product-luminette-2') && !inCart.includes('product-drive') ){
            firstRecomended = 'product-luminette-3'
        }else if( inCart.includes('product-luminette-3') && inCart.includes('product-luminette-2') && !inCart.includes('product-drive') ){
            firstRecomended = 'product-drive'
        }else if( inCart.includes('product-luminette-3') && inCart.includes('product-drive') && !inCart.includes('product-luminette-2') ){
            firstRecomended = 'product-luminette-2'
        }else if( inCart.includes('product-luminette-2') && inCart.includes('product-drive') && !inCart.includes('product-luminette-3') ){
            firstRecomended = 'product-luminette-3'
        }else if( inCart.includes('product-luminette-3') && !inCart.includes('product-drive') ){
            firstRecomended = 'product-drive'
        }else if( inCart.includes('product-luminette-2') && !inCart.includes('product-drive') ){
            firstRecomended = 'product-drive'
        }else if( inCart.includes('product-drive') && !inCart.includes('product-luminette-3') ){
            firstRecomended = 'product-luminette-3'
        }else if( !inCart.includes('product-nose-rest-for-luminette-3')  ){
            firstRecomended = 'product-nose-rest-for-luminette-3'
        }else if( !inCart.includes('product-nose-rest-for-luminette-2')  ){
            firstRecomended = 'product-nose-rest-for-luminette-2'
        }else if( !inCart.includes('product-nose-rest-for-luminette-1')  ){
            firstRecomended = 'product-nose-rest-for-luminette-1'
        }else if( !inCart.includes('product-protection-case-for-luminette-3')  ){
            firstRecomended = 'product-protection-case-for-luminette-3'
        }else if( !inCart.includes('product-protection-case-for-luminette-3')  ){
            firstRecomended = 'product-protection-case-for-luminette-3'
        }else if( !inCart.includes('product-protection-case-for-the-drive')  ){
            firstRecomended = 'product-protection-case-for-the-drive'
        }


        let productAvailableFirst = productsAvailable.querySelector('.cart-product-item.first')
        if(productAvailableFirst){
            productAvailableFirst.classList.remove('first')
        }
        //let firstActive = false
        productAvailable.forEach((item) => {
            if(inCart.includes(item.dataset.productHandle)){
                item.classList.remove('active')
                item.classList.remove('first')
            }else{
                item.classList.add('active')
                //if(!firstActive){
                if(firstRecomended == item.dataset.productHandle){
                    item.classList.add('first')
                    //firstActive = true
                }
            }
        })
        
        if(productInCart.length > 1){
            inCartItemsContainer.classList.add('at-least-two')
        }else{
            inCartItemsContainer.classList.remove('at-least-two')
        }

        return

        productsAvailable.querySelectorAll('.cart-product-item').forEach((item) => {
            // if(item.classList.contains('primary-product')){
            //     //recomended.push(item.dataset.productHandle)    
            // }else{
            //     if( recomendedAccessories.includes(item.dataset.productHandle) ){
            //         recomended.push(item.dataset.productHandle)
            //     }
            // }
            if( recomendedAccessories.includes(item.dataset.productHandle) ){
                recomended.push(item.dataset.productHandle)
            }
            
        })
        
        recomended = recomended.filter( ( el ) => !inCart.includes( el ) )

        productsAvailable.querySelectorAll('.cart-product-item').forEach((item) => {
            if( recomended.includes(item.dataset.productHandle) ){
                item.classList.add('active')
            }else{
                item.classList.remove('active')
            }
        })
        
        // show or hide 'You may also like' title
        if( productsAvailable.querySelectorAll('.cart-product-item.active').length == 0 ){
            mayAlsoLike.classList.add('hidden')
        }else{
            mayAlsoLike.classList.remove('hidden')
        }

        if(productInCart.length > 1){
            inCartItemsContainer.classList.add('at-least-two')
        }else{
            inCartItemsContainer.classList.remove('at-least-two')
        }

    }

    function hideRelatedProductsAll(){
        productsAvailable.querySelectorAll('.cart-product-item').forEach((item) => {
            item.classList.remove('active')
        })
    }
    
  
    // toggle product Minimized
    function toggleMinimized(item, minimized = true){
        if( minimized == true ){
            item.classList.add('minimized')
            let itemBody = item.querySelector('.in-cart-item-body')
            if( itemBody ){
                //$(itemBody).slideUp()
            }
        }else{
            item.classList.remove('minimized')
            let itemBody = item.querySelector('.in-cart-item-body')
            if( itemBody ){
                //$(itemBody).slideDown()
            }
        }
    }


    // Footer info pop-ups
    const cartFooterInfoPopupButton = document.querySelectorAll('.cart-info-popup-button')
    cartFooterInfoPopupButton.forEach((item) => {
        item.addEventListener('click', (e) => {
            cartFooterPopupInfoClose()
            let targetID = item.dataset.target
            let targetObj = document.getElementById(targetID)
            if(targetObj){
                targetObj.classList.add('open')
            }

            //item.nextElementSibling.classList.add('open')
        })
    })

    document.addEventListener('click', (e) => {
        if( e.target.closest('.cart-info-popup-button') === null ){ 
            cartFooterPopupInfoClose()
        }
    })

    function cartFooterPopupInfoClose(){
        let openPopup = document.querySelectorAll('.cart-info-popup.open')
        if( openPopup.length ){
            openPopup.forEach((item) => {
                item.classList.remove('open')
            })
        }
    }



    // select QUANTITY variation 
    itemVariationHead.forEach((item) => {
        item.addEventListener('click', (e) => {
            let curProduct = item.closest('.in-cart-item')
            let curItemVariation = item.closest('.item-variation')
            if( !curItemVariation.classList.contains('active') ){
                let itemQt = parseInt(curItemVariation.dataset.quantity)
                if( curProduct.classList.contains('has-color-variants') && curItemVariation.dataset.colors === undefined ){
                    let defaultColors = new Array(itemQt).fill('blue')
                    curItemVariation.dataset.colors = defaultColors.join('-')
                }
                let oldActiveVariation = curProduct.querySelector('.item-variation.active')
                let oldActiveVariationList = oldActiveVariation.querySelector('.item-variation-items-list')
                let curItemVariationList = curItemVariation.querySelector('.item-variation-items-list')
                
                oldActiveVariation.classList.remove('active')
                curItemVariation.classList.add('active')
                
                let curPrice = curItemVariation.querySelector('.item-variation-price').innerHTML
                
                if(curProduct.classList.contains('has-image-variants')){
                    changeColorVariationImage(curProduct)
                }
                setUnitsQuantity()
                setWarrantyBulk(curProduct)
                saveState()
                discounts()
            }
        })
    })

    

    // enable bulk mode
    const inCartMoreUnitsButton = document.querySelectorAll('.in-cart-more-units')
    inCartMoreUnitsButton.forEach((item) => {
        item.addEventListener('click', (e) => {
            let curProduct = item.closest('.in-cart-item')
            setBulkMode(curProduct, true)
            bulkImageVariant(curProduct)
            setUnitsQuantity()
            saveState()
            discounts()
        })
    })


    // disable bulk mode
    const inCartLessUnitsButton = document.querySelectorAll('.in-cart-less-units')
    inCartLessUnitsButton.forEach((item) => {
        item.addEventListener('click', (e) => {
            let curProduct = item.closest('.in-cart-item')
            setBulkMode(curProduct, false)
            setUnitsQuantity()
            saveState()
            discounts()
        })
    })

    function setBulkMode(curProduct, enable){
        if( enable == true){
            // enable bulk mode
            let variationsContainerLess = curProduct.querySelector('.in-cart-item-variations')
            let variationsContainerMore = curProduct.querySelector('.in-cart-item-variations-more')
            curProduct.classList.add('more-units')
            let curProductActiveVariation = curProduct.querySelector('.item-variation.active')
            if(curProductActiveVariation){
                curProductActiveVariation.classList.remove('active')
                curProductActiveVariation.dataset.previouslyActive = 'true'
                //$(curProductActiveVariation.querySelector('.item-variation-items-list')).slideUp()
            }
            $( variationsContainerLess ).slideUp()
            $( variationsContainerMore ).slideDown()
        }else{
            let variationsContainerLess = curProduct.querySelector('.in-cart-item-variations')
            let variationsContainerMore = curProduct.querySelector('.in-cart-item-variations-more')
            curProduct.classList.remove('more-units')
            
            let labels = curProduct.querySelectorAll('.in-cart-item-head-image-qt-label')
            if(labels){
                labels.forEach((l) => {
                    l.classList.remove('active')
                    l.innerHTML = ''
                })
            }
            // set default variation
            let curProductVariation = curProduct.querySelector('.item-variation[data-previously-active="true"]')
            if(curProductVariation){
                delete curProductVariation.dataset.previouslyActive
                curProductVariation.classList.add('active')
                //$(curProductVariation.querySelector('.item-variation-items-list')).slideDown()
            }
            if(curProduct.classList.contains('has-image-variants')){
                changeColorVariationImage(curProduct)
            }
            $( variationsContainerLess ).slideDown()
            $( variationsContainerMore ).slideUp()
        }
        setWarrantyBulk(curProduct, enable)
        setWhatInTheBoxColorBulk(curProduct)
    }


    // Product Bulk inputs
    bulkQtMinusButton.forEach((item) => {
        item.addEventListener('click', (e) => {
            let input = item.nextElementSibling
            let inputValue = parseInt(input.value)
            
            // color variation
            let curProduct = item.closest('.in-cart-item')
            let curProductMinusButtons = curProduct.querySelectorAll('.bulk-qt-minus')
            if(curProduct.classList.contains('has-color-variants')){
                if( inputValue > 0){
                    inputValue--
                    input.value = inputValue
                }
    
                if( inputValue == 0){
                    item.disabled = true
                    //input.disabled = true
                    let indicator = curProduct.querySelector('[data-bulk-variation-color="'+input.id+'"]')
                    if(indicator){
                        indicator.classList.add('disabled')
                    }
                }
                var totalUnits = 0
                curProduct.querySelectorAll('.bulk-variation-color-input').forEach((input) => {
                    let colorQt = parseInt(input.value)
                    totalUnits = totalUnits + colorQt
                })
                if(totalUnits <= 4){
                    curProductMinusButtons.forEach((button) => {
                        button.disabled = true
                    })
                }
                
            }else{
                if( inputValue > 4){
                    inputValue--
                    input.value = inputValue
                }
                if( inputValue <= 4){
                    curProductMinusButtons.forEach((button) => {
                        button.disabled = true
                    })
                }
            }
            bulkImageVariant(curProduct)
            setUnitsQuantity()
            saveState()
            discounts()
        })
    })

    bulkQtPlusButton.forEach((item) => {
        item.addEventListener('click', (e) => {
            let input = item.previousElementSibling
            let inputValue = parseInt(input.value) + 1
            let curProduct = item.closest('.in-cart-item')
            input.value = inputValue
            
            //$(item).siblings('.bulk-qt-minus').attr('disabled', false)
            item.parentElement.querySelector('.bulk-qt-minus').disabled = false;

            //input.disabled = false
            let indicator = curProduct.querySelector('[data-bulk-variation-color="'+input.id+'"]')
            if(indicator){
                indicator.classList.remove('disabled')
            }
            
            if(curProduct.classList.contains('has-color-variants')){
                var totalUnits = 0
                curProduct.querySelectorAll('.bulk-variation-color-input').forEach((input) => {
                    let colorQt = parseInt(input.value)
                    totalUnits = totalUnits + colorQt
                })
                if(totalUnits > 4){
                    curProduct.querySelectorAll('.bulk-variation-color-input').forEach((input) => {
                        if(input.value > 0){
                            input.previousElementSibling.disabled = false
                        }
                    })
                }
                
            }
            bulkImageVariant(curProduct)
            setUnitsQuantity()
            saveState()
            discounts()
        })
    })


    // bundle image and colors
    function bulkImageVariant(curProduct){
        if( curProduct.classList.contains('has-color-variants') ){
            let labels = curProduct.querySelectorAll('.in-cart-item-head-image-qt-label')
            labels.forEach((l) => {
                l.classList.remove('active')
                l.innerHTML = ''
            })
            var colors = []
            var colorsAll = ''
            var qt = 0

            curProduct.querySelectorAll('.bulk-variation-color-input').forEach((input, index) => {
                let colorQt = input.value
                let color = input.dataset.bulkColor
                if( colorQt != 0 ){
                    colors.push(color)
                    qt++
                    let label = curProduct.querySelector('.image-qt-label-'+index)
                    if(label){
                        label.innerHTML = 'x'+colorQt
                        label.classList.add('active')
                    }
                }
            })
            if( colors.length != 0 ){
                colorsAll = colors.sort().join('-')
                let productHandle = curProduct.id
                let img_url = getImageUrl( productHandle+'-'+colorsAll+'-qt-'+qt+'-2x' )
                let img = curProduct.querySelector('.item-variation-more-head-image-wrp img')
                changeProductImage(img, img_url)
            }


            // set background color
            let bgObj = curProduct.querySelector('.in-cart-item-variations-more-inner')
            bgObj.dataset.color = colorsAll
            
             

            setWhatInTheBoxColorBulk(curProduct)
            return
        }else{
            let productHandle = curProduct.id
            let input = curProduct.querySelector('.bulk-variation-input')
            let qt = input.value
            
            let label = curProduct.querySelector('.in-cart-item-head-image-qt-label')
            if(label){
                label.classList.add('active')
                label.innerHTML = 'x'+qt
            }
            
            if( curProduct.classList.contains('has-image-variants') ){
                let img_url = getImageUrl( productHandle+'-qt-1-2x' )
                let img = curProduct.querySelector('.item-variation-more-head-image-wrp img')
                changeProductImage(img, img_url)
            }
        }
    }

    
    function getImageUrl(handle){
        if( handle in images_url){
            return images_url[handle]
        }else{
            console.log(handle);
            return '//myluminette.com/cdn/shop/t/16/assets/no-image.png'
        }
    }

    // warranty select
    cartWarrantyItem.forEach((item) => {
        item.addEventListener('click', (e) => {
            if(!item.classList.contains('disabled')){
                let warrantyContainer = item.closest('.cart-warranty-items')
                warrantyContainer.querySelector('.cart-warranty-item.active').classList.remove('active')
                item.classList.add('active')
                saveState()
                discounts()
            }
        })
    })

    function setWarrantyBulk(curProduct, bulk = null){
        if( curProduct.querySelector('.cart-warranty-item.warranty-extended') ){
            if( curProduct.classList.contains('more-units') || bulk == true ){
                curProduct.querySelector('.cart-warranty-item.warranty-extended').classList.add('bulk')
                return
            }
            let curProductQuantity = parseInt(curProduct.querySelector('.item-variation.active').dataset.quantity)
            if( curProductQuantity > 1 ){
                curProduct.querySelector('.cart-warranty-item.warranty-extended').classList.add('bulk')
            }else{
                curProduct.querySelector('.cart-warranty-item.warranty-extended').classList.remove('bulk')
            }
        }
    }


    //  select product variation COLOR
    productVariantSelectorRadio.forEach((item) => {
        item.addEventListener('click', (e) => {
            let curProduct = item.closest('.in-cart-item')
            setVariation(item)
            changeColorVariationImage(curProduct)
            saveState()
        })
    })

    function setWhatInTheBoxColor(item){
        return
        let curProduct = item.closest('.in-cart-item')
        if( !curProduct.classList.contains('has-color-variants') ){
            return
        }
        let color = item.dataset.color
        curProduct.querySelector('.product-box-info-image.active').classList.remove('active')
        curProduct.querySelector('.product-box-info-image.color-'+color).classList.add('active')
    }

    function setWhatInTheBoxColorBulk(curProduct){
        return
        if( !curProduct.classList.contains('has-color-variants') ){
            return
        }
        if( curProduct.classList.contains('more-units') ){
            var colorVariation = ''
            curProduct.querySelectorAll('.bulk-variation-color-input').forEach((input) => {
                if( input.value != 0 && colorVariation == '' ){
                    colorVariation = input.dataset.bulkColor
                }
            })
            curProduct.querySelector('.product-box-info-image.active').classList.remove('active')
            curProduct.querySelector('.product-box-info-image.color-'+colorVariation).classList.add('active')
        }else{
            
            let el = curProduct.querySelector('.item-variation.active .product-variant-selector-radio[data-index="1"]:checked')
            let color = el.dataset.color
            curProduct.querySelector('.product-box-info-image.active').classList.remove('active')
            curProduct.querySelector('.product-box-info-image.color-'+color).classList.add('active')
        }
    }
    
    function setVariation(item){
        if( item.dataset.index == 1){
            setWhatInTheBoxColor(item)
        }

        const colors = []
        const colorsAll = []
        let variation = item.closest('.item-variation')
        let curVariationItem = item.closest('.item-variation-items-list')
        
        curVariationItem.querySelectorAll('.item-variation-item').forEach((variant) => {
            let color = variant.querySelector('input[type="radio"]:checked').dataset.color
            if( !colors.includes(color) ){
                colors.push(color)
            }
            colorsAll.push(color)
        })
        variation.dataset.color = colors.sort().join('-')
        variation.dataset.colors = colorsAll.sort().join('-')
    }

    function changeColorVariationImage(curProduct){
        let curItemVariation = curProduct.querySelector('.item-variation.active')
        if( curItemVariation === null ){
            console.error("Appliaction error: curItemVariation is null") 
            return
        }
        
        let product = curProduct.id
        let qt = curItemVariation.dataset.quantity
        if( qt > 3 ){
            qt = 3
        }
        let color = curItemVariation.dataset.colors
        if( color === undefined){
            color = 'blue'
        }
        
        if( product == 'product-luminette-3'){
            img_url = getImageUrl(product + '-' + color + '-qt-' + qt + '-' + '2x')
            let img = curProduct.querySelector('.item-variation.active .item-variation-head-image img')
            if( img_url != img.src.replace(/^http:/, '') ){
                changeProductImage(img, img_url)
            }
            
        }else{
            img_url = getImageUrl(product + '-qt-' + qt + '-' + '2x')
        }
        //let img = curProduct.querySelector('.in-cart-item-head-image img')
        //changeProductImage(img, img_url)

    }

    function changeProductImage(img, img_url){
        if(img.src.replace('https:', '') != img_url){
            img.classList.add('fade')
            setTimeout(() => {
                img.src = img_url    
            }, "100")
            setTimeout(() => {
                img.classList.remove('fade')
            }, "200")
        }
    }

    function setUnitsQuantity(){
        unitsInCartTotalDiscountAffects = 0
        let activeProducts = document.querySelectorAll('.in-cart-item.active')
        let totalQuantity = 0
        activeProducts.forEach((curProduct) => {
            let curProductQuantity = 0
            if( curProduct.classList.contains('more-units') ){
                // bulk mode
                curProduct.querySelectorAll('.bulk-variation-input').forEach((item) => {
                    curProductQuantity = curProductQuantity + parseInt(item.value)
                })
                curProduct.querySelector('.item-variation-more-head-units-qt-num').innerHTML = curProductQuantity
            }else{
                // retail mode
                curProductQuantity = curProduct.querySelector('.item-variation.active').dataset.quantity
            }
            curProduct.querySelector('.in-cart-item-minimized-info-units-num').innerHTML = curProductQuantity
            curProduct.dataset.unitsTotal = curProductQuantity
            totalQuantity = totalQuantity +  parseInt(curProductQuantity)
            if( productDiscountList[curProduct.id].affects_discount ){
                unitsInCartTotalDiscountAffects += parseInt(curProductQuantity)
            }
        })

        let itemsIndicator = document.querySelectorAll('.cart-items-count')
        let cartItemsIndicator = document.getElementById('sidebar-cart-items-indicator')
        
        if( totalQuantity == 0){
            itemsIndicator.forEach((item) => {
                item.innerHTML = ''
                item.classList.add('hidden')
                cartItemsIndicator.classList.add('hidden')
                let pe = item.parentElement
                if( pe.id == 'sidebar-cart-open' || pe.id == 'header-mobile-sidebar-cart-open-button' ){
                    pe.classList.remove('has-items')
                }
            })
        }else{
            itemsIndicator.forEach((item) => {
                item.classList.remove('hidden')
                cartItemsIndicator.classList.remove('hidden')
                item.innerHTML = totalQuantity
                let pe = item.parentElement
                if(pe.id == 'sidebar-cart-open' || pe.id == 'header-mobile-sidebar-cart-open-button' ){
                    pe.classList.add('has-items')
                }
            })
        }
        
    }

    function preloadAllImages(){
        for (let url of Object.values(images_url)) {
            preloadImage( url)
        }
    }

    function preloadImage(url) {
        var image = new Image()
        image.src = url
        image.loading = 'lazy'
        return image
    }

    function get_discount( quantity ){
        if(quantity <= 1){
            return 0
        }else if(quantity == 2){
            return 20
        }else if(quantity < 6){
            return 25
        }else if(quantity < 12){
            return 30
        }else if(quantity < 24){
            return 35
        }else{
            return 40
        }
    }

    function displayTaxElements(){
        const trust_elem = document.querySelectorAll(".product-selector-footer-bottom-2");

        trust_elem.forEach(elem => elem.remove());
        const cart_in_footer = document.querySelector("#products-in-cart-footer");

        const product_in_cart_tax = document.querySelector(".product-in-cart-tax");
        product_in_cart_tax.style.display = "flex";

        cart_in_footer.style.padding = "0";
        cart_in_footer.style.height = "133px";

        const cart_in_footer_top = document.querySelector(".products-in-cart-footer-top");
        cart_in_footer_top.style.padding = "20px 32px 3px 28px";

        const showModalBtn = document.getElementById('tax-info-icon');
        const modal = document.getElementById('tax-modal-note');

        function showModal() {
            modal.classList.add('show');
        }

        function hideModal() {
            modal.classList.remove('show');
        }

        showModalBtn.addEventListener('click', showModal);

        modal.addEventListener('click', hideModal);
    }

    // Checkout
    cartCheckoutButton.addEventListener('click', async (e) => {
        let region = cartSidebar.dataset.region
            
        if (region in taxRegions){// if region is in taxRegions check the checkbox
            const checkbox = document.getElementById('product-in-cart-tax-checkbox');
            const taxElement = document.querySelector('.product-in-cart-tax');
    
            if (!checkbox.checked) {
                taxElement.classList.add('shake-animation');
                
                setTimeout(() => {
                    taxElement.classList.remove('shake-animation');
                    taxElement.style.border = "1px solid rgba(78, 169, 255, 0.33)";
                }, 1000);
    
                return 1;
            }
        }
            
        let response = await fetch( window.Shopify.routes.root + "cart/clear.js")
        const result = await response.json()
        if ( response.ok ){

            let state = getState()
            var warranty = 0
            const formData  = {items: []}
            state.forEach((product) => {
                product.items.forEach((item) => {
                    formData.items.push(
                        {
                            id: item.variantId, 
                            quantity: parseInt(item.quantity),
                        }
                    )
                })
                if( product.warranty == 1 ){
                    warranty = warranty + parseInt(product.totalUnits)
                }
            })
            if( warranty > 0 ){
                formData.items.push(
                    {
                        id: extendedWarrantyID,
                        quantity: warranty
                    }
                )
            }
            
        
            let response = await fetch(
                window.Shopify.routes.root + 'cart/add.js', 
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(formData),
                }
            )

            const result = await response.json()
            if ( response.ok ){
                console.log(response)
                if(window.location.hash != '#test'){
                    window.location = window.Shopify.routes.root + "checkout"
                }
                
            }
        }

        
    })


    // footer reposition
    
    document.addEventListener("scroll", () => {
        footerReposition()
    });
    window.addEventListener("resize", () => {
        footerReposition()
    });

    function footerReposition(){
        let csi = document.querySelector('.cart-sidebar-main-inner')
        let mobileMenuWrp = document.querySelector('.header-mobile-menu-wrp')
        if(mobileMenuWrp){
            let height = window.innerHeight - 73
            csi.style.height = height+'px'
            let mobileMenuHeight = window.innerHeight
            mobileMenuWrp.style.height = mobileMenuHeight+'px'
        }
    }
    



    // menu scroll toggle
    var lastScrollTop = 0;
    const header2 = document.getElementById('header-2')
    const sections = document.querySelectorAll('[data-theme]')

    function scrollToggle(){
        var st = window.pageYOffset || document.documentElement.scrollTop;
        if( !document.body.classList.contains('mobile-menu-open') ){
            
            if ( st < 10 ){
                header2.classList.remove('up-scroll')
                header2.classList.remove('down-scroll')
            } else if (st > lastScrollTop) {
                header2.classList.remove('up-scroll')
                header2.classList.add('down-scroll')
            } else if (st < lastScrollTop) {
                header2.classList.remove('down-scroll')
                header2.classList.add('up-scroll')
            }
        }
        
        lastScrollTop = st <= 0 ? 0 : st
    }

    function throttle(fn, wait) {
        var timeoutID = null;
        return function() {
            if (!timeoutID) {
                clearTimeout(timeoutID);
                timeoutID = setTimeout(function() {
                    fn();
                    timeoutID = null;
                }, wait);
            }
        }
    }

    let optimizedscrollToggle = throttle(scrollToggle, 100)

    if(header2){

        document.addEventListener("scroll", optimizedscrollToggle)

        document.addEventListener("scroll", () => {
            getTopSection()
        })
        
        document.addEventListener('DOMContentLoaded', () => {
            getTopSection()
            // var st = window.pageYOffset || document.documentElement.scrollTop;
            // if( !document.body.classList.contains('mobile-menu-open') ){
            //     if ( st > 10 ){
            //         header2.classList.add('up-scroll')
            //     }
            // }
        })

        function getTopSection(){
            let curOffset = 0
            sections.forEach((section) => {
                let top = section.getBoundingClientRect().top
                let bottom = section.getBoundingClientRect().bottom
                if( bottom > 0 && top <= 0 ){
                    if( section.dataset.theme == 'dark' ){
                        header2.classList.remove('light')
                        header2.classList.add('dark')
                    }else if( section.dataset.theme == 'light' ){
                        header2.classList.remove('dark')
                        header2.classList.add('light')
                    }
                }
            })
        }
    }
    

    // menu other toggle
    const headerMenuDdToggleButton = document.querySelector('.header-menu-dd-other-toggle')
    const headerMenuOther = document.getElementById('header-menu-other')
    if(headerMenuDdToggleButton){
        headerMenuDdToggleButton.addEventListener('click', (e) => {
            headerMenuDdToggleButton.closest('.desktop-menu-menu-item').classList.toggle('dd-open')
            //headerMenuOther.classList.toggle('dd-open')
        })
        document.addEventListener('click', (e) => {
            if( e.target.closest('.needsclick') ){
                return false
            }
            if ( !headerMenuOther.contains(e.target) && !headerMenuDdToggleButton.contains(e.target) ) {
                headerMenuDdToggleButton.closest('.desktop-menu-menu-item').classList.remove('dd-open')
            }
        })
    }
   
    


    // menu other toggle list
    const otherMenuToggleListButton = document.getElementById('header-menu-other-list-toggle-button')
    const otherMenu = document.querySelector('.header-menu-other-wrp')
    if( otherMenuToggleListButton ){
        otherMenuToggleListButton.addEventListener("click", function(){ 
            otherMenu.classList.toggle('expanded')
        })
    }


    // submenu open
    const menuButtonHasChildren = document.querySelectorAll('.desktop-menu-menu-item.has-children')
    const headerDesktopMenuUl = document.querySelector('.header-desktop-menu')
    menuButtonHasChildren.forEach((item) => {
        item.addEventListener('click', (e) => {
            if (e.target.closest('.desktop-menu-submenu-item.item-accessories')){
                if(! e.target.closest('.menu-product-item-button.menu-product-item-add-to-cart')){
                    return false;
                }
            }
            if( !item.classList.contains('open') ){
                document.querySelectorAll('.desktop-menu-menu-item.has-children.open').forEach((el) => {
                    el.classList.remove('open')
                })
                item.classList.add('open')
                headerDesktopMenuUl.classList.add('submenu-open')
            }else{
                item.classList.remove('open')
                //headerDesktopMenuUl.classList.remove('submenu-open')
            }
        })
    })

    document.addEventListener('click', (e) => {
        if( e.target.closest('.needsclick') ){
            return false
        }

        if( e.target.closest('.desktop-menu-menu-item.has-children.open') == null ){
            document.querySelectorAll('.desktop-menu-menu-item.has-children.open').forEach((el) => {
                el.classList.remove('open')
            })
        }
    })



    const productAddToCartButtonOnPage = document.querySelectorAll('.product-add-to-cart-button')
    productAddToCartButtonOnPage.forEach((item) => {
        item.addEventListener('click', (e) => {
            let handle = item.dataset.productHandle
            let currentProductEl = document.getElementById(handle)
            if( currentProductEl !== null ){
                addProduct(currentProductEl)
                cartSidebar.classList.add('step-2')
                saveState()
                
                window.setTimeout(function(){
                    document.body.classList.add('sidebar-open')
                }, 200);
            }
        })
    })

    const menuItemAddToCartButton = document.querySelectorAll('.menu-product-item-add-to-cart')
    menuItemAddToCartButton.forEach((item) => {
        item.addEventListener('click', (e) => {
            let handle = item.dataset.productHandle
            let currentProductEl = document.getElementById(handle)
            mobileMenuAccessoriesToggle()
            if( currentProductEl !== null ){
                addProduct(currentProductEl)
                cartSidebar.classList.add('step-2')
                saveState()
                
                window.setTimeout(function(){
                    document.body.classList.remove('mobile-menu-open')
                    document.body.classList.add('sidebar-open')
                }, 200);
            }
        })
    })


    const mobileMenuToggleButton = document.querySelector('.mobile-menu-toggle-button')
    if(mobileMenuToggleButton){
        mobileMenuToggleButton.addEventListener('click', (e) => {
            if( document.body.classList.contains('mobile-menu-open') ){
                menuProductEl.style.marginTop = null
                mobileMenuWrp.classList.remove('accessories-open')
            }
            document.body.classList.toggle('mobile-menu-open')
        })
    }

    const menuOthertEl = document.querySelector('.mobile-menu-other')
    const menuProductEl = document.querySelector('.mobile-menu-product-item-outer')
    //const mobileMenuFooterEl = document.querySelector('.header-mobile-menu-footer')

    const mobileMenuAccessoriesToggleButton = document.getElementById('mobile-menu-accessories-toggle')
    if(mobileMenuAccessoriesToggleButton){
        mobileMenuAccessoriesToggleButton.addEventListener('click', (e) => {
            mobileMenuAccessoriesToggle()
        })
    }
    
        
    // mobile menu other toggle list
    const mobileOtherMenuToggleListButton = document.querySelector('.mobile-menu-other-list-toggle')
    const dummy = document.querySelector('.dummy')
    if( mobileOtherMenuToggleListButton ){
        mobileOtherMenuToggleListButton.addEventListener("click", function(){ 
            menuOthertEl.classList.toggle('expanded')
            setTimeout(() => {
                mobileOtherMenuToggleListButton.scrollIntoView({ behavior: "smooth" })
            }, "310")
        })
    }

    const headerMobileSupportWrp = document.querySelector('.header-mobile-support-wrp');
    const headerMobileSupportButton = document.getElementById('header-mobile-support-button-toggle');
    if( headerMobileSupportButton ){
        headerMobileSupportButton.addEventListener('click', (e) => {
            headerMobileSupportWrp.classList.add('active')
        })

        document.body.addEventListener('click', (e) => {
            if( !e.target.closest('.header-mobile-support-popup')  && !e.target.closest('#header-mobile-support-button-toggle')  ){
                headerMobileSupportWrp.classList.remove('active');
            }
        })
    }

    const headerMobileSidebarCartOpenButton = document.querySelectorAll('.header-mobile-sidebar-cart-open')
    if(headerMobileSidebarCartOpenButton){
        headerMobileSidebarCartOpenButton.forEach((item) => {
            item.addEventListener('click', (e) => {
                document.body.classList.remove('mobile-menu-open')
                setTimeout(() => {
                    document.body.classList.add('sidebar-open')
                }, "200")
            })
        })
    }
    

    const cartOpenButton = document.querySelectorAll('.cart-open-button')
    if(cartOpenButton){
        cartOpenButton.forEach((item) => {
            item.addEventListener('click', (e) => {
                if( item.dataset.productHandle ){
                    let handle = item.dataset.productHandle
                    let currentProductEl = document.getElementById(handle)
                    if( currentProductEl !== null ){
                        addProduct(currentProductEl)
                        cartSidebar.classList.add('step-2')
                        saveState()
                        window.setTimeout(function(){
                            document.body.classList.add('sidebar-open')
                        }, 200);
                    }
                }else{
                    window.setTimeout(function(){
                        document.body.classList.add('sidebar-open')
                    }, 200);
                }
            })
        })
    }


    

    function mobileMenuAccessoriesToggle(){
        if( !mobileMenuWrp.classList.contains('accessories-open') ){
            menuOthertEl.classList.remove('expanded')
            let h = menuProductEl.offsetHeight
            menuProductEl.style.marginTop = '-'+h+'px'
            mobileMenuWrp.classList.add('accessories-open')
        }else{
            menuProductEl.style.marginTop = null
            mobileMenuWrp.classList.remove('accessories-open')
        }
    }
    

    function safari_detector(){
        if( navigator.userAgent.includes("Safari") || navigator.userAgent.includes("iPhone") ) {
            document.body.classList.add('safari')
        }
    }

    
    function setTaxInFooter(){
        if(footerTaxContainer){
            let region = cartSidebar.dataset.region
            if (region in taxRegions){
                if(region == 'ch'){
                    console.log(document.getElementById('product-tax-text-wrp'));
                    document.getElementById('product-tax-text-wrp').classList.add("product-in-cart-tax-switzerland");
                    const style = document.createElement("style");
                    style.textContent = `
                    @media(max-width: 380px){
                        .product-in-cart-tax p{
                            font-size: 11px !important;
                            line-height: 14px !important;
                        }
                        .product-in-cart-tax-checkbox-text{
                            font-size: 11px !important;
                            line-height: 14px !important;
                        }
                    }`;
                    document.head.appendChild(style);
                }
                displayTaxElements();
                let totalPrice = parseInt(checkoutButtonPriceEl.innerHTML)
                let taxRate = taxRegions[region].rate
                let taxCountry = taxRegions[region].country
                if(totalPrice){
                    let taxValue = totalPrice * taxRate / 100
                    let content = footerTaxValue.innerHTML;
                    let updatedContent = content.replace(/[\d.]+/g, '');
                    updatedContent += taxValue;
                    footerTaxValue.innerHTML = updatedContent;
                    //footerTaxText.innerHTML = ' ('+taxRate+'% local '+taxCountry+' tax)'
                }
            }else{
                footerTaxContainer.classList.add('hidden');
                const taxElement = document.querySelector('.product-in-cart-tax');
                taxElement.style.display = "none";
            }
        }
    }

    
    function translsteDiscountTagNew(qt){
        if (qt <= 1){
            return '';
        }
        if(qt > 24) {
            return '-'+productDiscountAmounts[24]+'%';
        }
        let units = 'units'+qt;
        if(units in tagTranslationAll){
            let t = tagTranslationAll[units]
            return t
        }else{
            return '-'+productDiscountAmounts[qt]+'%';
        }
    }

    function translsteDiscountTagOrderTogether(qt){
        if (qt <= 1){
            return '';
        }
        if(qt > 24) {
            return '-'+productDiscountAmounts[24]+'%';
        }
        let units = 'units'+qt;
        if(units in tagTranslationOrderTogether){
            let t = tagTranslationOrderTogether[units]
            return t
        }else{
            return '-'+productDiscountAmounts[qt]+'%';
        }
    }

    function translsteAccessoriesDiscountTagNew(qt){
        if (qt <= 1 || qt == undefined){
            return '';
        }
        if(qt > 24) {
            return '-'+accessoriesDiscountAmounts[24]+'%';
        }
        let units = 'units'+qt;
        if(units in tagAccessoriesTranslationAll){
            let t = tagAccessoriesTranslationAll[units]
            return t
        }else{
            return '-'+accessoriesDiscountAmounts[qt]+'%';
        }
    }


    function getProductImageById(id){
        if(id in productImages){
            return productImages[id]
        }else{
            return null
        }
    }

    function getProductTitleById(id){
        if(id in productTitles){
            return productTitles[id]
        }else{
            return null
        }
    }

    function getPromotionalPrice(price){
        if(cartSidebar.classList.contains('cart-promotional') && cartSidebar.dataset.promotional ){
            let percentage = parseInt(cartSidebar.dataset.promotional)
            return (100 - percentage) / 100 * price
        }else{
            return price
        }
    }

    
    
    // 2025 design

    const footerSupportButton = document.querySelectorAll('.product-selector-footer-support-button')
    const footerSupportDropdown = document.querySelectorAll('.product-selector-footer-support-dropdown-wrp')
    const cartSidebarHeader = document.querySelector('.cart-sidebar-header')

    footerSupportButton.forEach((el) => {
        el.addEventListener('click', (e) => {
            el.nextElementSibling.classList.add('open')
            cartSidebarHeader.style.opacity = '0'
        })
    })
    
    document.body.addEventListener('click', (e) => {
        if( !e.target.classList.contains('product-selector-footer-support-button') ){
            footerSupportDropdown.forEach((el) => {
                el.classList.add('closing')
                setTimeout(() => {
                    el.classList.remove('open')
                    el.classList.remove('closing')
                    cartSidebarHeader.style.opacity = ''
                }, 300)
            })
        }
    })

    const footerTrustedButton = document.querySelectorAll('.product-selector-footer-trusted-button')
    const footerTrustedDropdown = document.querySelectorAll('.product-selector-footer-trusted-popup')
    
    footerTrustedButton.forEach((el) => {
        el.addEventListener('click', (e) => {
            el.nextElementSibling.classList.add('open')
        })
    })

    document.body.addEventListener('click', (e) => {
        if( !e.target.classList.contains('product-selector-footer-trusted-button') ){
            footerTrustedDropdown.forEach((el) => {
                el.classList.remove('open')
            })
        }
    })
    

    // accessories menu

    const accessoriesListWrp = document.getElementById('accessories-list-wrp')
    const accessoriesListHead = document.querySelector('.accessories-list-head')
    const accessoriesList = document.querySelector('.accessories-list')
    const accessoriesListItem = document.querySelectorAll('.accessories-list-item')

    accessoriesListHead.addEventListener('click', (e) => {
        accessoriesListWrp.classList.toggle('open')
        $(accessoriesList).slideToggle('fast', function() {
            // let activeProduct = document.querySelector('.product-selector-item.active')
            // if(activeProduct){
            //     activeProduct.classList.remove('active')
            // }
            // let accessoriesList = document.querySelectorAll('.accessories-list-item')
            // let selectedItem = document.querySelectorAll('.accessories-list-item.active')
            // console.log(selectedItem);
            // accessoriesList.forEach((item) => {
            //     if(!item.classList.contains('out-of-stock') && selectedItem.length == 0){
            //         item.classList.add('active')
            //         selectedItem = item
            //     }
            // })
            scrollToAccessoriesSmooth()
        })
    })

    accessoriesListItem.forEach((item) => {
        item.addEventListener('click', (e) => {
            if(!item.classList.contains('active') && !item.classList.contains('out-of-stock')){
                let activeAccessoryItem = document.querySelector('.accessories-list-item.active')
                if(activeAccessoryItem){
                    activeAccessoryItem.classList.remove('active')
                }
                let activeProductItem = document.querySelector('.product-selector-item.active')
                if(activeProductItem){
                    activeProductItem.classList.remove('active')
                }
                item.classList.add('active')
            }
        })

        item.addEventListener("touchstart", (e) => {
            item.classList.add('touched')
        })
        item.addEventListener("touchend", (e) => {
            item.classList.remove('touched')
        })
    })
   
    function scrollToAccessoriesSmooth() {
        const parentContainer = document.getElementById('product-selector-list');
        const accessoriesElement = document.getElementById('accessories-list-wrp');
        if (parentContainer && accessoriesElement) {
            const marginBottom = parseInt(window.getComputedStyle(accessoriesElement).marginBottom);
            const scrollPosition = accessoriesElement.offsetTop - parentContainer.clientHeight + accessoriesElement.offsetHeight + marginBottom;
            parentContainer.scrollTo({
                top: scrollPosition,
                behavior: 'smooth'
            });
        }
    }

    const productsBottom = document.querySelector('.cart-products-bottom')
    const productsShowMore = document.getElementById('cart-products-show-more')
    const productsShowLess = document.getElementById('cart-products-show-less')
    productsShowMore.addEventListener('click', (e) => {
        productsBottom.classList.add('more')
        
        setTimeout(scrollToCartBottom, 300)

    })
    productsShowLess.addEventListener('click', (e) => {
        productsBottom.classList.remove('more')
    })

    function scrollToCartBottom() {
        const container = document.getElementById('products-in-cart');
        const bottomElement = document.querySelector('.cart-products-bottom');

        if (container && bottomElement) {
          const containerRect = container.getBoundingClientRect();
          const bottomRect = bottomElement.getBoundingClientRect();
      
          const scrollTop = bottomRect.top - containerRect.top;
      
          container.scrollTo({
            top: scrollTop,
            behavior: 'smooth' // Добавляем плавную прокрутку
          });
        }
    }



}
